import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { isEmptyArray } from '@common/helpers';
import { AppliedMealList, Meal, TravelerMealInfo } from '@common/interfaces/mybooking/order-services.interface';
import { PassengerType } from '@common/interfaces/mybooking/passenger-type';
import { FlightMealService } from '@common/services/my-booking/flight-meal-service/flight-meal-service';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { Subscription } from 'rxjs';
import { GetMealResponseData, GetOrderResponseData } from 'src/sdk-servicing';
import { Traveler } from 'src/sdk-servicing/model/traveler';
import { Type1 } from 'src/sdk-servicing/model/type1';

@Component({
  selector: 'asw-flight-meal-information',
  templateUrl: './flight-meal-information.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightMealInformationComponent extends SupportComponent {
  /** 当該セグメント情報 */
  @Input() flight!: Type1;
  @Input() traveler!: Traveler;
  departureAirport!: string;
  arrivalAirport!: string;
  pnr!: GetOrderResponseData;
  meal!: GetMealResponseData;
  _subscriptions: Subscription = new Subscription();
  appliedMealList: AppliedMealList[] = [];
  isNotAppliedMeal: boolean = false;
  hasAppliedMeal: boolean = true;
  isBabyMeal: boolean = false;

  constructor(
    private readonly _common: CommonLibService,
    private readonly _flightMealService: FlightMealService,
    public _changeDetectorRef: ChangeDetectorRef
  ) {
    super(_common);
  }

  init(): void {
    this._subscriptions.add(
      this._flightMealService.inFlightMealRequestData$.subscribe((data) => {
        this.pnr = data.pnr ?? ({} as GetOrderResponseData);
        this.meal = data.meal ?? ({} as GetMealResponseData);
        this.getAirportName();
        this.getMealInflight();
        this._changeDetectorRef.markForCheck();
      })
    );
  }

  /** Get airport name */
  getAirportName() {
    // [1.2.7] 当該セグメント情報.departure.locationCodeを引数として、「当画面共通処理No1.空港名称取得処理」を行い、返却値の空港名称≠""""(空欄)の場合、空港名称を表示する。
    let departureAirportName = this._flightMealService.onHandleCommonNo1(this.flight.departure?.locationCode!);
    this.departureAirport = departureAirportName !== '' ? departureAirportName : this.flight.departure?.locationName!;

    // [1.2.8] 当該セグメント情報.arrival.locationCodeを引数として、「当画面共通処理No1.空港名称取得処理」を行い、返却値の空港名称≠""""(空欄)の場合、空港名称を表示する。
    let arrivalAirportName = this._flightMealService.onHandleCommonNo1(this.flight.arrival?.locationCode!);
    this.arrivalAirport = arrivalAirportName !== '' ? arrivalAirportName : this.flight.arrival?.locationName!;
  }

  getMealInflight() {
    /** 申込済機内食情報 */
    const inFlightMealInforApply = (((this.pnr?.services?.meal ?? {}) as Meal)?.[this.flight.id!]?.[
      this.traveler.id!
    ] ?? {}) as TravelerMealInfo;
    // [1.2.9] 機内食選択
    if (this.traveler.passengerTypeCode !== PassengerType.INF) {
      // [1.2.9.2] 上記以外の場合、申込済機内食情報.appliedMealListの要素(以降、申込済情報)数分繰り返し、以降の項目を設定する。
      this.appliedMealList = inFlightMealInforApply.appliedMealList ?? [];
      if (isEmptyArray(this.appliedMealList)) {
        this.hasAppliedMeal = false;
      }
    } else {
      this.isBabyMeal = true;
    }
  }

  override reload(): void {
    /* override abstract reload of base class*/
  }

  override destroy(): void {
    if (this._subscriptions) {
      this._subscriptions.unsubscribe();
    }
  }
}
